import { useMemo } from 'react';
import { RadioWrapper } from '../../../../radio/RadioWrapper';
import { RadioGroupComponent } from '../../../../radio/RadioGroup';
import styles from './SyncFrequencyWithSyncOnDemand.module.scss';
import { SyncTypeFeatureOptions } from '../../../interfaces/pipeline-settings-config';
import { IntegrationSyncTypesFactory } from '../../../factories/integrationFactory';

export interface SyncFrequencyWithSyncOnDemandProps {
  currentValue: string;
  defaultValue: string;
  onChange: (value: string) => void;
  featureOptions: SyncTypeFeatureOptions;
}

export function SyncFrequencyWithSyncOnDemand({
  currentValue,
  defaultValue,
  onChange,
  featureOptions
}: SyncFrequencyWithSyncOnDemandProps) {
  const recommendedMode = featureOptions.default_value;

  const syncTypes = useMemo(() => {
    return IntegrationSyncTypesFactory(featureOptions.options, recommendedMode);
  }, [featureOptions, recommendedMode]);

  if (syncTypes.length <= 1) {
    return null;
  }

  return (
    <RadioGroupComponent
      id='sync-type'
      name='createNewDestination'
      currentValue={currentValue}
      defaultValue={defaultValue}
      onChange={onChange}
      className={styles.syncFrequencyRadioGroupContainer}
    >
      {syncTypes.map(syncType => (
        <RadioWrapper
          key={syncType.id}
          dataId={`sync-type-${syncType.id}`}
          radioProps={{ value: syncType.value }}
          label={syncType.label}
          variant='outline'
          description={syncType.description}
          isActive={currentValue === syncType.value}
          activeClassName={styles.isActive}
          wrapperClassName={styles.syncFrequencyRadioOptionContainer}
        />
      ))}
    </RadioGroupComponent>
  );
}
